"use client";

import { switchBookAction } from "@/app/book-actions";
// ⚠ ここは "use client"。lib/db から import すると Prisma・better-sqlite3 が
//    ブラウザ用バンドルに入り、ビルドが落ちて全ページ 500 になる（2026-07-31 に実際に発生）。
//    帳簿一覧は Node 依存を持たない lib/books から取ること。
import { BOOKS as BOOK_KEYS, BOOK_LABEL } from "@/lib/books";

// 帳簿の一覧は lib/db.ts の BOOKS から生成する。
// 手書きリストにしていたため、帳簿を増やすと切替ボタンに出ない事故が起きうる状態だった（2026-07-31 修正）。
const BOOKS: { key: string; label: string }[] = BOOK_KEYS.map((k) => ({ key: k, label: BOOK_LABEL[k] }));

/** 事業（帳簿）切替。個人事業と法人は別DB。選択すると全画面が切り替わる。 */
export function BookSwitcher({ active }: { active: string }) {
  return (
    <div
      className="flex items-center gap-0.5 rounded-[var(--radius-sm)] p-0.5"
      style={{ background: "var(--surface-2)", border: "1px solid var(--border)" }}
    >
      {BOOKS.map((b) => {
        const isActive = b.key === active;
        return (
          <form action={switchBookAction} key={b.key}>
            <input type="hidden" name="book" value={b.key} />
            <button
              type="submit"
              disabled={isActive}
              className="rounded-[calc(var(--radius-sm)-2px)] px-3 py-1 text-[12px] font-semibold transition-colors"
              style={{
                background: isActive ? "var(--accent)" : "transparent",
                color: isActive ? "#ffffff" : "var(--text-muted)",
                cursor: isActive ? "default" : "pointer",
              }}
            >
              {b.label}
            </button>
          </form>
        );
      })}
    </div>
  );
}
